import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

function MainLayout() {
  // Add effect to remove any yellow outlines
  useEffect(() => {
    // Create a style element
    const style = document.createElement('style');
    // Add CSS rules to remove any yellow outlines
    style.textContent = `
      * {
        outline: none !important;
        border-color: transparent !important;
      }
      
      .MuiBox-root, .MuiContainer-root, .MuiPaper-root {
        outline: none !important;
        border: none !important;
      }
    `;
    // Append the style element to the document head
    document.head.appendChild(style);

    // Clean up
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Box
      className="main-layout-container"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        overflow: 'hidden',
        position: 'relative',
        '& *': {
          outline: 'none !important',
        }
      }}
    >
      <Box
        className="content-wrapper"
        sx={{
          flex: 1,
          position: 'relative',
          zIndex: 1
        }}
      >
        <Outlet />
      </Box>
      <Footer />
      <WhatsAppButton />
    </Box>
  );
}

export default MainLayout; 